import { useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { formatMobileNumber, isValidMobileNumber } from 'utils/mobileNumberValidation';
import { SEND_MOBILE_VERIFICATION_CODE_MUTATION } from '../mutations/graphql';

export const useMobileNumberVerification = (form, mobileNumberVerified = false, setError = undefined) => {
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [mobileNumberToVerify, setMobileNumberToVerify] = useState('');
  const [isMobileNumberVerified, setIsMobileNumberVerified] = useState(mobileNumberVerified);
  const [currentValues, setCurrentValues] = useState({});
  const [errorVerification, setErrorVerification] = useState('');
  const [isMobileNumberValid, setIsMobileNumberValid] = useState(false);
  const [sendMobileVerificationCode, { loading: sendLoading }] = useMutation(SEND_MOBILE_VERIFICATION_CODE_MUTATION);

  useEffect(() => {
    if (!form) return;
    const unsubscribe = form.subscribe(
      ({ values }) => {
        const mobileNumber = values?.plainMobileNumber || values?.mobileNumber || '';
        setIsMobileNumberValid(isValidMobileNumber(mobileNumber));

        setCurrentValues(values);
      },
      { values: true }
    );

    return () => unsubscribe();
  }, [form]);

  const handleSendVerificationCode = async () => {
    const mobileNumberValue = currentValues.plainMobileNumber || currentValues.mobileNumber;
    const mobileNumber = formatMobileNumber(mobileNumberValue);

    try {
      const { data } = await sendMobileVerificationCode({
        variables: {
          mobileNumber: mobileNumber,
        },
      });
      const result = data?.sendMobileVerificationCode;

      if (result?.success) {
        setErrorVerification('');
        setMobileNumberToVerify(mobileNumber);
        setShowVerificationModal(true);
      } else {
        setErrorVerification(result?.message || 'Failed to resend verification code');
      }
    } catch (error) {
      setErrorVerification('An error occurred while sending verification code. Please try again.');
    }
  };

  useEffect(() => {
    setIsMobileNumberVerified(mobileNumberVerified);
  }, [mobileNumberVerified]);

  return {
    showVerificationModal,
    setShowVerificationModal,
    mobileNumberToVerify,
    isMobileNumberVerified,
    setIsMobileNumberVerified,
    handleSendVerificationCode,
    currentValues,
    errorVerification,
    setErrorVerification,
    isMobileNumberValid,
  };
};
